import * as React from 'react'
import Card from 'material-ui/Card/Card'
import ActionSearch from 'material-ui/svg-icons/action/search'
import creiosTheme from '../Theme/creiosTheme'
import injectSheet from 'react-jss'
import Input from 'material-ui-next/Input'
import {WithClasses} from './Helper'

const styles = {
    root: {
        display: 'inline-block',
        marginLeft: '20px',
    },
    card: {},
    content: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        padding: '0 16px',
    },
    icon: {
        marginRight: '12px',
    },
    input: {
        height: '48px',
        lineHeight: '24px',
        padding: 0,
    },
}

interface Properties {

}

export const AppBarSearch =
    injectSheet(styles)(
        ({classes}: WithClasses<Properties>) => (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <div className={classes.content}>
                        <ActionSearch
                            className={classes.icon}
                            color={creiosTheme.palette.secondaryColor}
                        />
                        <Input
                            placeholder="Suche"
                            disableUnderline={true}
                            classes={{input: classes.input}}
                        />
                    </div>
                </Card>
            </div>
        ),
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/AppbarSearch.tsx